import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["running-as-you-get-older"]!;

export function Body() {
  return (
    <>
      <p>
        Many runners start or keep running well into their forties, fifties and beyond. What
        happens to endurance with age, and what can training keep?
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers from the University of Texas and the University of Colorado reviewed
        research on older endurance athletes, often called masters athletes. They described how
        peak endurance performance changes with age and which parts of the body's capacity
        explain it.
      </p>

      <h2>What they found</h2>
      <p>
        Peak endurance performance held up until about 35 years of age. After that it fell
        modestly until 50 to 60, and more steeply after that.
      </p>
      <p>
        The main reason was a gradual drop in maximal oxygen uptake. The lactate threshold also
        fell. Running economy, how much energy you use at a given pace, did not change with age
        in trained runners.
      </p>
      <p>
        The authors concluded that much of the decline comes from the fact that older athletes
        train at lower speeds and do less training.
      </p>

      <h2>What it means for you</h2>
      <p>
        Some decline is inevitable, but less of it is fixed than many think. Keeping some faster
        running in your week matters as you get older, because intensity is the part of
        training that tends to disappear first.
      </p>
      <p>
        Economy is something you keep. Many older runners run very efficiently, and strength
        training can help keep the muscles strong.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        Much of the data comes from comparing the best results at different ages, not from
        following the same runners over many years. How fast an individual runner declines
        varies a lot.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training builds your targets from your own recent races and runs, not from your age.
        As your form changes, your targets change with it, and your recovery decides how the
        harder sessions are spaced.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Tanaka & Seals (2008), Endurance exercise performance in Masters athletes:
          age-associated changes and underlying physiological mechanisms.{" "}
          <a href="https://doi.org/10.1113/jphysiol.2007.141879">The Journal of Physiology</a>.
        </li>
      </ul>
    </>
  );
}
